import React from 'react';
import StorefrontPage from '../../components/core/StorefrontPage';
import { StorefrontCartContainer } from './containers/storefront-cart.container';

/**
 * StorefrontCartShellPage — public storefront cart shell.
 * Wires StorefrontCartContainer into the /shop/cart OpenRoute.
 */
const StorefrontCartShellPage: React.FC = () => {
    return (
        <StorefrontPage>
            <StorefrontCartContainer />
        </StorefrontPage>
    );
};

export default StorefrontCartShellPage;
